import { get } from '@/lib/http';
import { endpoints } from './endpoints';
import type { NavigationResponse } from '@/types';

/**
 * The sidebar and scanner tab bar, as decided by the backend.
 *
 * There is deliberately no client-side menu to fall back on: whatever this
 * returns is what the user may see, and it already matches what the API will
 * actually let them call.
 */
export const navigationApi = {
  current: () => get<NavigationResponse>(endpoints.navigation.current),
};
